const CustomRoamingPoint = () =>
  import("./customRoamingPoint/CustomRoamingPoint.vue");
const CustomRoamingPerspective = () =>
  import("./customRoamingPerspective/CustomRoamingPerspective.vue");
const mapSwiper = () => import("@/components/common/swiper/Index.vue");
const importRoutePage = () => import("./importRoutePage.vue");
let graphicLayer, graphicLayer2, roamLine;
let isStarted = false;
let watchPoints;
let watchPointsData = [
  { text: "观察点1", position: [114.168324, 22.561181, 27.9] },
  { text: "观察点2", position: [114.164303, 22.563148, 38.4] },
  { text: "观察点3", position: [114.161564, 22.562186, 36.9] },
  { text: "观察点4", position: [114.158644, 22.562244, 20.8] },
];
// import { DistanceLegend } from 'mars3d';
//按需加载
import {
  selectRoaming,
  selectRoamingPoint,
  addRoaming,
  editRoaming,
  deleteRoaming,
  deleteRoamingPoint,
  selectRoamingPointDetail,
  addListBimRoamPoints,
  selectRoamingPointpage,
} from "../../../api/api";
import { exportExcel } from "@/utils/utils.js";
import proj4 from "proj4";

import { EventBus } from "../../../static/js/event-bus.js";
import * as roamTest from "./map.js";
import * as screenRecorderMap from "@/components/tables/screenRecorder/map.js";
import _ from "lodash";

export default {
  components: {
    CustomRoamingPoint,
    CustomRoamingPerspective,
    mapSwiper,
    importRoutePage,
  },
  props: {},
  data() {
    return {
      customRoaming_show: true,
      radioValue: "",
      currentPage: 1, //当前分页展示页码。
      prevPage: 1, //跳转到点位面板前漫游路径名称面板里的当前页码，方便跳转回来时该页码不变。
      paginationShow: false, //解决换Tab页时的页码显示不正确的bug。
      pageSize: 10, //当前表格每页展示的数据条数。
      totalRows: 0, //数据总条数。
      tableData: [],
      imgList: [],
      showimg: false,
      //参数单位是千米/每小时，所以value需要换算一下，方便直接用。
      options: [
        // {
        //   name: "20 公里/小时",
        //   value: 20,
        // },
        // {
        //   name: "50 公里/小时",
        //   value: 50,
        // },
        {
          name: "60 公里/小时",
          value: 60,
        },
        {
          name: "80 公里/小时",
          value: 80,
        },
        {
          name: "100 公里/小时",
          value: 100,
        },
        {
          name: "120 公里/小时",
          value: 120,
        },
        {
          name: "200 公里/小时",
          value: 200,
        },
        {
          name: "500 公里/小时",
          value: 500,
        },
        // {
        //   name: "1000 公里/小时",
        //   value: 1000,
        // },
        // {
        //   name: "2000 公里/小时",
        //   value: 2000,
        // },
        // {
        //   name: "5000 公里/小时",
        //   value: 5000,
        // },
      ],
      showPath: false, //true,
      speedChoose: 100,
      prevSpeed: 100, //方便算倍率。
      routeForm: {
        pathName: "",
      },
      routeFormRules: {
        pathName: [
          {
            required: true,
            message: "请输入路线名称",
            trigger: "blur",
          },
        ],
      },
      //为避免混淆和潜在的逻辑缺陷，所以这里修改表单数据单独用个js对象变量存着。
      routeEditForm: {
        pathName: "",
        id: "",
      },
      showAddForm: false,
      showDetailTab: false,
      open_roaming_box: "", //当前打开的漫游子弹窗，最多只同时显示一个子弹窗。
      camera: {
        Type: "dy", //'gs', //视角设置参数：视角模式类型。
        Radius: 100,
        FollowedX: 200, //视角设置参数：锁定第一视角时，距离运动点的距离（后方）。
        FollowedZ: 100, //视角设置参数：锁定第一视角【dy】或平面视角【sd】时，距离运动点的高度（上方）。
        //closeToTerrain:false,
      },
      paused: false, //是否按下了暂停按钮
      isFold: false, //是否最小化
      isRowChange: false,
      isStopDrawPoint: true,
      maxPointName: "",
      selectedRowIndex: -1,
      projectId: null,
      isScreencap: null,
      importRouteShow: false,
      totalPage: 0,
    };
  },
  mounted() {
    this.projectId = parseInt(window.sessionStorage.getItem("nowProjectId"));
    // this.$refs["multipleTable"].$nextTick(function () {
    //            this.escrollY(
    //              ".el-table__body-wrapper",
    //              ".el-table__header-wrapper"
    //            );
    // 		   console.log('触发！');
    //          })
    if (!graphicLayer) {
      graphicLayer = new mars3d.layer.GraphicLayer();
      this.$GLOBAL.map.addLayer(graphicLayer);
    }

    if (!graphicLayer2) {
      graphicLayer2 = new mars3d.layer.GraphicLayer(); //飞行漫游矢量图层，避免影响其它图层展示。
      this.$GLOBAL.map.addLayer(graphicLayer2);
    }

    this.initData();

    /* let that = this;
    document.onkeydown = function(e) {
      if (e.code === "Space" || e.code === "Enter") {
        if (roamLine) {
          if (roamLine.isPause) {
            that.customRoaming_continue();
          } else {
            if (roamLine.isStart) {
              that.customRoaming_pause();
            } else {
              that.customRoaming_begin();
            }
          }
        } 
      }
    }; */

    // $(document).keypress(function (e) {
    // 	// 回车和空格按下事件
    //    if (e.keyCode == 32) {
    // 		if(roamLine){
    // 			if(roamLine.isPause){
    // 				that.customRoaming_continue();
    // 			}else{
    // 				if(roamLine.isStart){
    // 					that.customRoaming_pause();
    // 				}else{
    // 					that.customRoaming_begin();
    // 				}
    // 			}
    // 		}else{
    // 			that.$alert('请先在表格中，选中您想要开始漫游的路线。', '友情提示', {
    // 				confirmButtonText: '确定',
    // 				callback: action => {}
    // 			});
    // 			return false;
    // 		}
    //     }
    // })
  },
  methods: {
    // 导出点位
    exportPoint() {
      // 检验选中
      if (!this.radioValue) {
        this.$alert("请先选择要导出的路径（只支持单选）", "友情提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return false;
      }
      // 请求数据
      const data = {
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        bimRoamId: this.radioValue,
        sortField: "sort",
        sortOrder: "descend",
      };
      // 所有项目
      const projectInfoArrJson = JSON.parse(
        sessionStorage.getItem("projectInfoArrJson")
      );
      // 当前项目的proj4
      const fromProjection = projectInfoArrJson.find(
        (item) => item.id == data.projectId
      )?.proj4;
      // 请求
      selectRoamingPoint(data).then((res) => {
        const list = res.data.data;
        let newCoordinates = "";
        // 有值情况
        if (list && list.length > 0) {
          list.forEach((item, index) => {
            // xy经纬度数组
            let arr = [Number(item.x), Number(item.y)];
            // 固定WGS84
            const toProjection = `GEOGCS["WGS 84",DATUM["WGS_1984",SPHEROID["WGS 84",6378137,298.257223563,AUTHORITY["EPSG","7030"]],
                                  AUTHORITY["EPSG", "6326"]], PRIMEM["Greenwich", 0, AUTHORITY["EPSG", "8901"]],
                                  UNIT["degree", 0.0174532925199433, AUTHORITY["EPSG", "9122"]], AUTHORITY["EPSG", "4326"]]`;
            // proj4存在
            if (fromProjection) {
              // 转换出坐标
              const proj4List = proj4(toProjection, fromProjection, arr);
              proj4List.push(Number(item.z));
              newCoordinates += `p${index},` + proj4List.toString() + "\n";
            }
          });
          if (newCoordinates) {
            const blob = new Blob([newCoordinates]);
            const fileName = `${this.routeEditForm.pathName}.txt`;
            const link = document.createElement("a"); // 创建a标签
            link.download = fileName; // a标签添加属性
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click(); // 执行下载
            URL.revokeObjectURL(link.href); // 释放url
            document.body.removeChild(link); // 释放标签
          }
        }
      });
    },
    drawWatchPoints(arr) {
      var that = this;
      // 判断路径图层是否存在
      if (!watchPoints) {
        watchPoints = new mars3d.layer.GraphicLayer();
        this.$GLOBAL.map.addLayer(watchPoints);
      } else {
        // 清除路径图层内所有矢量数据
        watchPoints.clear();
      }
      // graphicDots - 当前点对象 , position - 点坐标, iurl - 点的样式 ，rPColor - 文字的颜色
      let position, graphicDots, iurl, rPColor;
      rPColor = "#ffffff";
      iurl = require("@/../public/img/marker/bimVideo/surveilffffff.png");

      //videoDotsArr = [];
      // 循环创建视频点
      arr.forEach((item) => {
        position = item.position;
        graphicDots = new mars3d.graphic.BillboardEntity({
          position: new mars3d.LngLatPoint(
            position[0],
            position[1],
            position[2]
          ),
          style: {
            image: iurl,
            scale: 1,
            scaleByDistance: true,
            scaleByDistance_farValue: 0.8,
            scaleByDistance_far: 1000,
            scaleByDistance_near: 100,
            pixelOffset: new Cesium.Cartesian2(0, -6), // 偏移量
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
              0.0,
              1500
            ), // 按视距显示
            highlight: {
              scale: 1.2,
            },
            label: {
              //不需要文字时，去掉label配置即可
              text: item.text,
              font_size: 20,
              font_family: "黑体",
              color: rPColor,
              outline: true,
              strokeColor: "#000000",
              outlineColor: "#000000",
              outlineWidth: 3,
              // outline: true,
              pixelOffsetY: -70,
              visibleDepth: false,
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
                0.0,
                1500
              ), // 按视距显示
            },
            visibleDepth: false,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
            //clampToGround: true, //贴地
          },
        });
        watchPoints.addGraphic(graphicDots);
        //videoDotsArr.push(graphicDots);
        item.uid = graphicDots.uuid;

        // 单点绘制不需要监听
        // 鼠标移入事件
        graphicDots.on("mouseOver", (e) => {
          that.showimg = false;
          that.customRoaming_pause();
        });
        // 鼠标移出事件
        graphicDots.on("mouseOut", (e) => {
          var currView = that.$GLOBAL.map.getCameraView();
          roamLine.setCameraOptions({
            type: that.camera.Type,
            //radius: that.camera.Type == "gs" ? that.camera.Radius : 0,
            heading: currView.heading,
            pitch: currView.pitch,
            //followedX: that.camera.Type == "dy" ? that.camera.FollowedX : 0,
            //followedZ: that.camera.Type != "gs" ? that.camera.followedZ : 0,
          });
          that.customRoaming_continue();
        });
        // 点击事件
        graphicDots.on("click", (e) => {
          that.watchPointClick();
        });
      });
    },
    watchPointClick() {
      //console.log("mouse click!!!");
      this.imgList = [
        {
          src: require("@public/text/2.jpg"),
        },
        {
          src: require("@public/text/3.png"),
        },
        {
          src: require("@public/text/4.png"),
        },
      ];
      this.showimg = true;
    },
    customRoamingBox_close() {
      //this.customRoamingTable_show=false;
      //alert("触发");
      // alert('触发！');
      if (watchPoints) {
        watchPoints.clear();
        //this.$GLOBAL.map.removeLayer(watchPoints, true);
      }
      this.$GLOBAL.map.setCursor(false);
      if (this.$GLOBAL.markDrawGraphicLayer2 != undefined) {
        this.isStopDrawPoint = true;
        this.$GLOBAL.markDrawGraphicLayer2.stopDraw();
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.unregisterKeyEvent();
      this.$emit("customRoamingBox_close");
    },
    customRoamingBox_fold() {
      if (this.isFold) {
        this.isFold = false;
      } else {
        this.isFold = true;
      }
    },
    closeNewGrouping() {
      this.importRouteShow = false;
      this.customRoamingBox_fold();
      this.initData();
    },
    customRoamingBoxFoldPausePlay() {
      if (roamLine.isPause) {
        this.customRoaming_continue();
      } else {
        this.customRoaming_pause();
      }
    },
    registerKeyEvent() {
      let that = this;
      document.onkeydown = (e) => {
        if (e.code === "Space" || e.code === "Enter") {
          if (roamLine) {
            if (roamLine.isPause) {
              roamLine.proceed();
              that.paused = false;
            } else {
              if (roamLine.isStart) {
                roamLine.pause();
                that.paused = true;
              } else {
                roamLine.start();
                that.paused = false;
              }
            }
          }
        }
      };
    },
    unregisterKeyEvent() {
      document.onkeydown = (e) => {};
    },
    initBaseSet() {
      this.paginationShow = false;
      //切换页面时重置一些基本设置信息
      if (this.showDetailTab) {
        this.prevPage = this.currentPage;
        this.currentPage = 1;
      } else {
        this.currentPage = this.prevPage;
        //如果之前勾选了显示路径，那么应该恢复路径显示。
        //alert(this.currentPage)
      }
      this.pageSize = 10;
      this.totalRows = 0;
      this.tableData = [];
      this.initData();
    },
    customRoaming_begin() {
      // 临时设置允许进入地下。
      //this.$GLOBAL.map.scene.cameraController.enableCollisionDetection = false; // 这样写会报错。
      const options = { cameraController: {} };
      options.cameraController["enableCollisionDetection"] = false;
      //console.log("更新了地图参数", options);
      this.$GLOBAL.map.setSceneOptions(options);

      let that = this;
      if (!this.radioValue) {
        this.$alert("请先在表格中，选中您想要开始漫游的路线。", "友情提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return false;
      }
      this.isRowChange = false;
      isStarted = true;
      this.searchDataRoaming();
      // this.drawWatchPoints(watchPointsData);
      this.registerKeyEvent();
    },
    customRoaming_pause() {
      if (roamLine) {
        roamLine.pause();
        this.paused = true;
        if (this.isScreencap) {
          screenRecorderMap.stop();
          setTimeout(() => {
            screenRecorderMap.download();
          }, 3000);
        }
        this.unregisterKeyEvent();
      } else {
        this.$alert("只有开始漫游了，才能暂停哦~", "友情提示", {
          confirmButtonText: "确定",
          type: "warning",
          callback: (action) => {},
        });
      }
    },
    customRoaming_continue() {
      if (roamLine) {
        roamLine.proceed();
        this.paused = false;
        this.registerKeyEvent();
      } else {
        this.$alert("漫游状态出错了，请点击“开始”按钮重新漫游吧~", "友情提示", {
          confirmButtonText: "确定",
          type: "error",
          callback: (action) => {},
        });
      }
    },
    rowClick(row) {
      console.log("row", JSON.parse(JSON.stringify(row)));
      this.routeEditForm.id = row.id;
      this.routeEditForm.pathName = row.name;
      this.open_roaming_box = "CustomRoamingPerspective";
      switch (row.viewMode) {
        case 0:
          this.camera.Type = "gs";
          this.camera.Radius = row.distance;
          break;
        case 1:
          this.camera.Type = "dy";
          this.camera.FollowedX = row.distance;
          this.camera.FollowedZ = row.height;
          break;
        case 2:
          this.camera.Type = "sd";
          this.camera.FollowedZ = row.height;
          break;
        default:
          break;
      }
      this.$refs.customRoamingPerspective.initFormData(this.camera);
    },
    roamingPathF(val) {
      if (val) {
        if (!this.radioValue) {
          this.$alert(
            "请在表格中，选中您想要查看路径的漫游路线。",
            "友情提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {},
            }
          );
          return false;
        }
        this.showPath = true;
        console.log(this.radioValue);
        this.drawLine(this.radioValue);
      } else {
        graphicLayer.clear();
      }
    },
    screencap(val) {
      if (val) {
        this.isScreencap = true;
        screenRecorderMap.init(60, 8500000);
      } else {
        this.isScreencap = false;
      }
    },
    customRoamingPerspectiveChange(params) {
      this.open_roaming_box = ""; //关闭视角设置弹窗。
      this.camera.Type = params.perspective;
      this.camera.Radius = params.perspectiveRadius;
      this.camera.FollowedX = params.perspectiveDistance;
      this.camera.FollowedZ = params.perspectiveHeight;
      let that = this;
      let viewMode = 1;
      let distance = 200;
      let height = 100;
      //alert(params.perspective);
      switch (this.camera.Type) {
        case "gs":
          viewMode = 0;
          distance = this.camera.Radius;
          height = 0;
          break;
        case "dy":
          viewMode = 1;
          distance = this.camera.FollowedX;
          height = this.camera.FollowedZ;
          break;
        case "sd":
          viewMode = 2;
          distance = 0;
          height = this.camera.FollowedZ;
          break;
        default:
          viewMode = 1;
          distance = 200;
          height = 100;
          break;
      }
      let rData = {
        id: this.routeEditForm.id,
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        name: this.routeEditForm.pathName,
        viewMode: viewMode,
        distance: distance,
        height: height,
      };
      editRoaming(rData).then(function (res) {
        if (res.data.success && res.data.code === 204) {
          that.$notify({
            title: "保存成功。",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
          that.initData();
        } else {
          that.$alert("修改漫游路径名称失败了，请再试一次吧~", "修改失败", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          });
        }
      });
      /* if(this.camera.closeToTerrain!==params.closeToTerrain){
				if (this.radioValue) {
					if(roamLine&&(roamLine.isStart||roamLine.isPause)){
						//如果保存切换视角结果中修改了是否贴地选项，则需要重新创建roamLine对象，因为setCameraOptions方法里没有提供修改贴地选项的参数。
						this.searchDataRoaming();
						if(roamLine.isPause){
							//如果保存切换视角结果时roamLine对象是暂停状态，则继续保持暂停状态。
							roamLine.pause();
							this.paused=true;
						}
					}
				}
				this.camera.closeToTerrain = params.closeToTerrain;
			}else{ */
      let change = false;
      if (roamLine && roamLine.isStart) {
        roamLine.pause();
        change = true;
      }
      //this.camera.closeToTerrain = params.closeToTerrain;
      if (roamLine) {
        roamLine.setCameraOptions({
          type: this.camera.Type,
          radius: this.camera.Type == "gs" ? this.camera.Radius : 0,
          followedX: this.camera.Type == "dy" ? this.camera.FollowedX : 0,
          followedZ: this.camera.Type != "gs" ? this.camera.FollowedZ : 0,
        });
      }
      if (roamLine && change) {
        roamLine.proceed();
      }
      /* } */

      //console.log(JSON.parse(JSON.stringify(params)));
      //console.log(11111111111111111);
    },
    getPathData(arr) {
      let that = this;
      // positionArr is not defined
      if (!arr.length) {
        that.$alert("当前路线暂无数据", "友情提示", {
          confirmButtonText: "确定",
          type: "warning",
          callback: (action) => {},
        });
        return;
      }

      let pointArr = [];
      arr.forEach((el, index) => {
        pointArr.push({
          x: el[0],
          y: el[1],
          z: el[2],
          // heading: "90",
          // pitch: "0",
          heading: el[3],
          pitch: el[4],
          projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
          bimRoamId: that.routeEditForm.id,
          pointName: index + 1,
          sort: 0,
        });
      });
      addListBimRoamPoints(pointArr).then((res) => {
        if (res.data?.code == 204) {
          that.$notify({
            title: "导入成功。",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
          this.closeNewGrouping();
        }
      });
    },
    manualFreed: _.throttle(() => {
      viewShed.manualFreed();
    }, 100),

    searchDataRoaming() {
      let that = this;
      let searchData = {
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        bimRoamId: this.radioValue,
        sortField: "sort",
        sortOrder: "ascend",
      };
      selectRoamingPoint(searchData).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          let pointArr = res.data.data;
          //pointArr.splice(0,1);
          let positionArr = pointArr.map((item) => {
            return [item.x, item.y, item.z];
          });
          console.log(positionArr);
          if (positionArr && positionArr.length >= 2) {
            let startHeading = parseFloat(pointArr[0]["heading"]);
            let startPitch = parseFloat(pointArr[0]["pitch"]);
            //设置自定义漫游初始视角
            let initX = parseFloat(pointArr[0]["x"]);
            let initY = parseFloat(pointArr[0]["y"]);
            let initZ = parseFloat(pointArr[0]["z"]);
            let initHeading = parseFloat(pointArr[0]["heading"]);
            let initPitch = parseFloat(pointArr[0]["pitch"]);
            console.log("**************");
            console.log(initHeading);
            console.log(initPitch);
            if (!isStarted) {
              that.$GLOBAL.map.setCameraView(
                {
                  lng: initX,
                  lat: initY,
                  alt: initZ + 50,
                  heading: initHeading,
                  pitch: initPitch,
                },
                {
                  duration: 2,
                }
              );
            }
            // return
            graphicLayer2.clear();
            // console.log(JSON.parse(JSON.stringify(pointArr)));
            // console.log(6666666666);
            //飞行漫游
            graphicLayer2.removeGraphic(roamLine);
            roamLine = null;
            roamLine = new mars3d.graphic.FixedRoute({
              name: "空中漫游",
              speed: that.prevSpeed, //轨迹速度，单位为千米/小时。
              multiplier: that.speedChoose / that.prevSpeed,
              //  path: {
              //   width: 10,
              //   color: '#ff0000',
              //   show: !that.showPath,//true,
              // },
              positions: positionArr,
              interpolation: true, //是否LagrangePolynomialApproximation插值，对轨迹进行圆弧状插值.
              interpolationAlgorithm: Cesium.LagrangePolynomialApproximation,
              /* offsetHeight: 10,
              interpolation:true,//是否LagrangePolynomialApproximation插值，对轨迹进行圆弧状插值.
              interpolationDegree:10,//当interpolation为true时，使用的插值程度。 */
              camera: {
                type: that.camera.Type,
                radius: that.camera.Type == "gs" ? that.camera.Radius : 0,
                followedX: that.camera.Type == "dy" ? that.camera.FollowedX : 0,
                followedZ: that.camera.Type != "gs" ? that.camera.FollowedZ : 0,
                heading: startHeading, //pointArr[0]['heading']||'',
                pitch: startPitch, //pointArr[0]['pitch']||'',
              },
              hasCache: true, //是否记录缓存。
              clockLoop: true, //是否循环播放
              interpolation: true, //是否LagrangePolynomialApproximation插值，对轨迹进行圆弧状插值.
              interpolationAlgorithm: Cesium.LagrangePolynomialApproximation,
              //interpolation: true, //setInterpolationOptions插值
              //interpolationDegree: 3,
            });
            graphicLayer2.addGraphic(roamLine);
            // mapWork.mapGetCameraView();

            roamLine.on(mars3d.EventType.change, (event) => {
              this.manualFreed();
            });

            /* if(that.camera.closeToTerrain){
							that.$message({
								message: '正在为您计算贴地路线，请稍候...',
								type: 'success',
								offset: 100,
								showClose: true,
								duration: 3000,
							});
							// 贴地时，异步计算完成后开始
							roamLine.clampToGround(function(e) {
								// 异步计算完成贴地后再启动
								// 贴地后的路线值为flyLine.points
								// console.log(e);
								// console.log(333333333333);
								roamLine.start();
							})
						}else{ */
            if (!that.isRowChange) {
              roamLine.start();
              that.isFold = true;
              that.paused = false;
              if (that.isScreencap) {
                screenRecorderMap.start();
              }
            }
            /* } */
          } else {
            that.$alert(
              "当前该漫游路径的点位数量不足2个，请先点击“点位”按钮添加点位吧。",
              "友情提示",
              {
                confirmButtonText: "确定",
                type: "warning",
                callback: (action) => {},
              }
            );
            that.showPath = false;
            return false;
          }
        } else {
          that.$alert(
            "当前该漫游路径还没有添加点位，请先点击“点位”按钮添加点位吧。",
            "友情提示",
            {
              confirmButtonText: "确定",
              type: "warning",
              callback: (action) => {},
            }
          );
          that.showPath = false;
          return false;
        }
      });
    },
    drawLineRaw(data) {
      let pointArr = data.map((item) => {
        return Cesium.Cartesian3.fromDegrees(item.x, item.y, item.z);
      });
      graphicLayer.clear();

      for (let i = 0; i < pointArr.length - 1; i++) {
        let position = mars3d.PolyUtil.getLinkedPointList(
          pointArr[i],
          pointArr[i + 1],
          0,
          50
        );
        let graphic = new mars3d.graphic.PolylineEntity({
          positions: position,
          style: {
            width: 10,
            // 动画线材质
            material: mars3d.MaterialUtil.createMaterialProperty(
              mars3d.MaterialType.LineFlow,
              {
                color: "#ff0000",
                image: "/img/textures/lineAarrow.png",
                speed: 20,
                repeat: new Cesium.Cartesian2(5, 1),
              }
            ),
            show: true,
            depthFail: true,
            depthFailColor: "#ff0000",
            depthFailMaterial: mars3d.MaterialUtil.createMaterialProperty(
              mars3d.MaterialType.LineFlow,
              {
                color: "#ff0000",
                image: "/img/textures/lineAarrow.png",
                speed: 20,
                repeat: new Cesium.Cartesian2(5, 1),
              }
            ),
          },
        });

        graphicLayer.addGraphic(graphic);
      }
    },
    drawLine(pathId) {
      let that = this;
      if (pathId) {
        let searchData = {
          projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
          bimRoamId: pathId,
          sortField: "sort",
          sortOrder: "descend",
        };
        selectRoamingPoint(searchData).then(function (res) {
          if (res.data.data && res.data.data.length > 0) {
            let pointArr = res.data.data;
            // console.log(JSON.parse(JSON.stringify(pointArr)));
            // console.log(1011111111111);
            if (pointArr && pointArr.length >= 2) {
              //alert(maxIndex)
              pointArr = pointArr.map((item) => {
                return Cesium.Cartesian3.fromDegrees(item.x, item.y, item.z);
              });

              graphicLayer.clear();

              for (let i = 0; i < pointArr.length - 1; i++) {
                let position = mars3d.PolyUtil.getLinkedPointList(
                  pointArr[i],
                  pointArr[i + 1],
                  0,
                  50
                );
                let graphic = new mars3d.graphic.PolylineEntity({
                  positions: position,
                  style: {
                    width: 5,
                    // 动画线材质
                    material: mars3d.MaterialUtil.createMaterialProperty(
                      mars3d.MaterialType.LineFlow,
                      {
                        color: "#ff0000",
                        image: "/img/textures/lineAarrow.png",
                        speed: 20,
                        repeat: new Cesium.Cartesian2(5, 1),
                      }
                    ),
                    show: true,
                    depthFail: true,
                    depthFailColor: "#ff0000",
                    depthFailMaterial:
                      mars3d.MaterialUtil.createMaterialProperty(
                        mars3d.MaterialType.LineFlow,
                        {
                          color: "#ff0000",
                          image: "/img/textures/lineAarrow.png",
                          speed: 20,
                          repeat: new Cesium.Cartesian2(5, 1),
                        }
                      ),
                  },
                });

                graphicLayer.addGraphic(graphic);
                //绘制路线时定位到漫游路线第一个点【优先按sort排序】效果更好。
                // if (i === 0) {
                // 	graphic.flyTo();
                // }
              }
              if (graphicLayer != undefined && roamLine != undefined) {
                if (graphicLayer && !roamLine.isStart) {
                  graphicLayer.flyTo();
                }
              }
            } else {
              that.$alert(
                "当前该漫游路径的点位数量不足2个，请先点击“点位”按钮添加点位吧。",
                "友情提示",
                {
                  confirmButtonText: "确定",
                  type: "warning",
                  callback: (action) => {},
                }
              );
              that.showPath = false;
              return false;
            }

            // console.log(JSON.parse(JSON.stringify(pointArr)));
            // return false;
            // const graphic = new mars3d.graphic.PolylineEntity({
            // 	positions: pointArr,
            // 	style: {
            // 		width: 5,
            // 		color: "#3388ff",
            // 		distanceDisplayCondition_near: 0,
            // 		distanceDisplayCondition_far: 100000,
            // 	},
            // 	show: true
            // })
            // graphicLayer.addGraphic(graphic);
            // graphic.flyTo();
          } else {
            that.$alert(
              "当前该漫游路径还没有添加点位，请先点击“点位”按钮添加点位吧。",
              "友情提示",
              {
                confirmButtonText: "确定",
                type: "warning",
                callback: (action) => {},
              }
            );
            that.showPath = false;
            return false;
          }
        });
      } else {
        that.$alert("参数缺失，无法绘制路径，请再试一次。", "友情提示", {
          confirmButtonText: "确定",
          type: "error",
          callback: (action) => {},
        });
        return false;
      }

      //this.$GLOBAL.map.setCameraView({ lng: 85.17, lat: 43.28, alt: 6000, heading: 5, pitch: -48 })
    },
    backRoamingBox() {
      this.showDetailTab = false;
      this.open_roaming_box = "";
      this.initBaseSet();
    },
    addRoute() {
      this.showAddForm = true;
    },
    addImportRoute() {
      this.importRouteShow = true;
      console.log(this.$refs.importRoutePage);
      this.customRoamingBox_fold();

      // setTimeout(() => {
      //   if (this.isFold) {
      //     this.isFold = false;
      //   } else {
      //     this.isFold = true;
      //   }
      // }, 1000);
    },
    pointRowClick(row) {
      //alert(row.uid)
      if (row.uid) {
        let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(row.uid);
        layer.flyTo({
          minHeight: 10,
          maxHeight: 200,
          duration: 2,
        });
      }
    },
    submitForm(formName) {
      let that = this;
      console.log(formName);
      if (formName === "routeForm") {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //alert('submit!');
            that.showAddForm = false;
            let rData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              name: this.routeForm.pathName,
              viewMode: 1,
              distance: 200,
              height: 100,
            };
            addRoaming(rData).then((res) => {
              if (res.data.success && res.data.code === 204) {
                that.initData();
                that.$notify({
                  title: "新增成功。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert(
                  "新增漫游路径名称失败了，请再试一次吧~",
                  "新增失败",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        // 先弹出提示框让用户确认提交修改，取消则不保存修改。
        that.$refs[formName].validate((valid) => {
          if (valid) {
            this.$confirm("确定修改该漫游路径名称吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                let viewMode = 1;
                let distance = 200;
                let height = 100;
                switch (that.camera.Type) {
                  case "gs":
                    viewMode = 0;
                    distance = that.camera.Radius;
                    height = 0;
                    break;
                  case "dy":
                    viewMode = 1;
                    distance = that.camera.followedX;
                    height = that.camera.followedZ;
                    break;
                  case "sd":
                    viewMode = 2;
                    distance = 0;
                    height = that.camera.followedZ;
                    break;
                  default:
                    viewMode = 1;
                    distance = 200;
                    height = 100;
                    break;
                }
                let rData = {
                  id: that.routeEditForm.id,
                  projectId: parseInt(
                    window.sessionStorage.getItem("nowProjectId")
                  ),
                  name: that.routeEditForm.pathName,
                  viewMode: viewMode,
                  distance: distance,
                  height: height,
                };
                editRoaming(rData).then(function (res) {
                  if (res.data.success && res.data.code === 204) {
                    // console.log(JSON.parse(JSON.stringify(res)));
                    // console.log(1111111111);
                    that.$notify({
                      title: "修改成功。",
                      message: "",
                      type: "success",
                      duration: 960,
                      offset: 320,
                    });
                    that.initData();
                  } else {
                    that.$alert(
                      "修改漫游路径名称失败了，请再试一次吧~",
                      "修改失败",
                      {
                        confirmButtonText: "确定",
                        type: "error",
                        callback: (action) => {},
                      }
                    );
                  }
                });
              })
              .catch(() => {
                that.$message({
                  type: "info",
                  message: "已取消修改",
                  offset: 100,
                  showClose: true,
                  duration: 1600,
                });
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    resetForm(formName) {
      // alert(formName)
      this.$refs[formName].resetFields();
      this.showAddForm = false;
    },
    roamingSpeedChange(value) {
      if (roamLine) {
        let rate = value / this.prevSpeed;
        roamLine.multiplier = rate;
      }
    },
    getCurrentRow(index, row) {
      if (!this.showDetailTab) {
        isStarted = false;
        graphicLayer2.clear();
        this.radioValue = row.id;
        //map.js示例
        //漫游开始
        //roamTest.handleCustomRoaming("start",this.radioValue);
        //漫游暂停
        //roamTest.handleCustomRoaming("pause",this.radioValue);
        //漫游继续
        //roamTest.handleCustomRoaming("continue",this.radioValue);
        //漫游停止
        //roamTest.handleCustomRoaming("stop",this.radioValue);
        //销毁漫游对象
        //roamTest.destroy();
        this.selectedRowIndex = index;
        if (this.$GLOBAL.markDrawGraphicLayer) {
          this.$GLOBAL.markDrawGraphicLayer.clear();
        }
        if (this.$GLOBAL.markDrawGraphicLayer2) {
          this.$GLOBAL.markDrawGraphicLayer2.clear();
        }

        if (this.showPath) {
          this.drawLine(this.radioValue);
        }
        this.$refs.singleTable.setCurrentRow(row);

        if (roamLine) {
          //roamLine.proceed();
          roamLine.stop();
          roamLine = null;
          this.paused = false;
        }

        this.isRowChange = true;
        this.searchDataRoaming();
      } else {
        this.$refs.singleTable2.setCurrentRow(row);
      }
      //console.log(index, JSON.parse(JSON.stringify(row)))
    },
    showDetail(index, row) {
      this.showAddForm = false;
      this.showDetailTab = true;
      this.routeEditForm.pathName = row.name;
      this.routeEditForm.id = row.id;
      this.initBaseSet();
      console.log(index, row.id);
    },
    deleteRoute(index, row) {
      let that = this;
      this.$confirm(
        "此操作将删除该漫游路径及其中所有点位信息，确定删除吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let drData = {
            id: row.id,
          };
          deleteRoaming(drData).then(function (res) {
            if (res.data.success && res.data.code === 204) {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(1111111111);
              that.$notify({
                title: "删除成功。",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              that.initData();
            } else {
              that.$alert("删除失败了，请再试一次吧~", "删除失败", {
                confirmButtonText: "确定",
                type: "error",
                callback: (action) => {},
              });
            }
          });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });

      console.log(index, row);
    },
    addRoamingPoint() {
      let that = this;
      let pathName = "";
      this.isStopDrawPoint = false;
      this.$refs.customRoamingPoint.isStopDrawPoint = false;
      if (this.routeEditForm.pathName) {
        //去除字符串两端空格
        pathName = this.routeEditForm.pathName.replace(/(^\s*)|(\s*$)/g, "");
      }
      if (pathName) {
        //this.open_roaming_box = "CustomRoamingPoint";
        this.$refs.customRoamingPoint.addRoamingPoint(
          pathName,
          this.routeEditForm.id
        );
      } else {
        this.$alert("漫游点所属路径名称不能为空。", "友情提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            that.routeEditForm.pathName = ""; //清除空格。
            that.$refs.eInput.focus();
          },
        });
      }
    },
    stopAddRoamingPoint() {
      this.$GLOBAL.map.setCursor(false);
      if (this.$GLOBAL.markDrawGraphicLayer2 != undefined) {
        this.isStopDrawPoint = true;
        this.$GLOBAL.markDrawGraphicLayer2.stopDraw();
      }
    },
    handleEditPointClick(index, row) {
      let that = this;
      let rpData = {
        id: row.id,
      };
      selectRoamingPointDetail(rpData).then((res) => {
        if (res.data.success && res.data.data) {
          let formData = res.data.data;
          formData.pathName = that.routeEditForm.pathName;
          formData.pathId = that.routeEditForm.id;
          formData.uid = row.uid;

          let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(
            formData.uid
          );
          layer.flyTo({
            duration: 2,
          });
          layer.hasEdit = true;

          this.$GLOBAL.markDrawGraphicLayerObj = layer;

          this.open_roaming_box = "CustomRoamingPoint";

          this.$refs.customRoamingPoint.initFormData(formData);
          // console.log(JSON.parse(JSON.stringify(that.routeEditForm)));
          // console.log(4444444444);
          // return false;

          this.$refs.customRoamingPoint.isEdit = true;
          this.$refs.customRoamingPoint.title = "编辑";
        }

        // console.log(JSON.parse(JSON.stringify(res)));
        // console.log(4444444444);
      });
      this.$refs.singleTable2.setCurrentRow(row);
      this.radioValue = row.id;
      // console.log(index, row);
    },
    deleteRoutePoint(index, row) {
      this.deleteRPData(row.id);
      this.$refs.singleTable2.setCurrentRow(row);
      this.radioValue = row.id;
      let maxPointName = parseInt(this.maxPointName) - 1;
      if (maxPointName != undefined)
        this.$refs.customRoamingPoint.oldPointName = maxPointName.toString();
      else this.$refs.customRoamingPoint.oldPointName = "-1";

      console.log(index, row);
    },
    deleteRPData(rpid) {
      if (!rpid) {
        this.$alert("请先选中您想要删除的漫游点位。", "友情提示", {
          confirmButtonText: "确定",
          type: "error",
          callback: (action) => {},
        });
        return false;
      }
      let that = this;
      this.$confirm("确定删除此漫游点位吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let rpData = {
            id: rpid,
          };
          deleteRoamingPoint(rpData).then(function (res) {
            if (res.data.success && res.data.code === 204) {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(1111111111);
              that.initData();
              that.$notify({
                title: "删除成功。",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            } else {
              that.$alert("删除失败了，请再试一次吧~", "删除失败", {
                confirmButtonText: "确定",
                type: "error",
                callback: (action) => {},
              });
            }
          });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initData();
      console.log(`当前页: ${val}`);
    },
    initData() {
      let that = this;
      //获取最新列表数据并展示
      let searchData = {
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
      };
      //this.currentPage=2;
      // alert(this.currentPage);
      if (this.showDetailTab) {
        /* 漫游点位 不分页 ，这样地图上选择点也不需要考虑所选者点所在的页码并实时更新当前页码 */
        searchData.bimRoamId = that.routeEditForm.id;
        searchData.sortField = "sort";
        searchData.sortOrder = "ascend";
        searchData.pageSize = this.pageSize;
        searchData.pageNo = this.currentPage;
        //alert(3)
        selectRoamingPointpage(searchData).then(function (res) {
          if (res.data.data?.rows.length > 0) {
            that.tableData = res.data.data.rows;
            that.totalPage = res.data.data.totalRows;
            // that.pageSize=res.data.data.pageSize;
            // that.currentPage=res.data.data.pageNo;
            // that.totalRows=res.data.data.totalRows;
            // that.paginationShow=true;
            //alert(2)
            that.tableData = that.initRPArray(that.tableData);
          } else {
            that.tableData = [];
            that.pageSize = 10;
            that.totalRows = 0;
            that.currentPage = 1;
            that.paginationShow = false;
            that.$refs.customRoamingPoint.initDefaultPointName();
          }
          // console.log(JSON.parse(JSON.stringify(that.tableData)));
          // console.log(2222222222);
          if (that.showPath && that.tableData.length >= 2) {
            that.drawLineRaw(that.tableData);
          } else {
            that.$refs.customRoamingPoint.form.pointName = (
              res.data.data.totalRows + 1
            ).toString();
            graphicLayer.clear();
          }
        });
      } else {
        searchData.pageSize = this.pageSize;
        searchData.pageNo = this.currentPage;

        selectRoaming(searchData).then(function (res) {
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            that.tableData = res.data.data.rows;
            that.pageSize = res.data.data.pageSize;
            that.currentPage = res.data.data.pageNo;
            //alert(res.data.data.pageNo);
            that.totalRows = res.data.data.totalRows;

            that.paginationShow = true;
          } else {
            that.tableData = [];
            that.pageSize = 10;
            that.totalRows = 0;
            that.currentPage = 1;
            that.paginationShow = false;
          }
          // console.log(JSON.parse(JSON.stringify(res)));
          // console.log(2222222222);
          //console.log(JSON.parse(JSON.stringify(that.tableData)));
          if (that.showPath && that.tableData.length > 0) {
            let rowIdx = 0;
            if (that.radioValue != "") rowIdx = that.selectedRowIndex;
            that.radioValue = that.tableData[rowIdx].id;
            that.routeEditForm.id = that.tableData[rowIdx].id;
            that.routeEditForm.pathName = that.tableData[rowIdx].name;
            //that.open_roaming_box = 'CustomRoamingPerspective';
            switch (that.tableData[rowIdx].viewMode) {
              case 0:
                that.camera.Type = "gs";
                that.camera.Radius = that.tableData[rowIdx].distance;
                break;
              case 1:
                that.camera.Type = "dy";
                that.camera.followedX = that.tableData[rowIdx].distance;
                that.camera.followedZ = that.tableData[rowIdx].height;
                break;
              case 2:
                that.camera.Type = "sd";
                that.camera.followedZ = that.tableData[rowIdx].height;
                break;
              default:
                break;
            }
            //that.$refs.customRoamingPerspective.initFormData(that.camera);
            that.drawLine(that.radioValue);
          }
        });
      }
    },
    initRPArray(data) {
      //根据数据库加载出来的项目的标记数据显示到地图上。
      if (!this.$GLOBAL.markDrawGraphicLayer) {
        //alert(1);
        this.$GLOBAL.markDrawGraphicLayer = new mars3d.layer.GraphicLayer({
          hasEdit: true,
          isAutoEditing: true, //绘制完成后是否自动激活编辑
        });
        this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer);

        let that = this;
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.editMovePoint,
          function (e) {
            var point = mars3d.LngLatPoint.fromCartesian(e.cartesian);
            point.format(); //经度、纬度、高度

            let currJD = point.lng;
            let currWD = point.lat;
            let currGD = point.alt;
            let cartesianXYZ = currJD + "," + currWD + "," + currGD;
            EventBus.$emit("updateCartesian", {
              cartesianXYZ: cartesianXYZ,
              graphic: e.graphic,
            });
          }
        );

        //绑定标绘相关事件监听(可以自行加相关代码实现业务需求，此处主要做示例)
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.drawStart,
          function (e) {
            console.log("开始绘制", e);
          }
        );
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.drawAddPoint,
          function (e) {
            console.log("绘制过程中增加了点", e);
          }
        );
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.drawRemovePoint,
          function (e) {
            console.log("绘制过程中删除了点", e);
          }
        );

        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.drawCreated,
          function (e) {
            console.log("创建完成", e);
          }
        );
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.editStart,
          function (e) {
            console.log("开始编辑", e);
          }
        );

        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.editRemovePoint,
          function (e) {
            console.log("编辑删除了点", e);
          }
        );
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.editStop,
          function (e) {
            console.log("停止编辑", e);
          }
        );
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.removeGraphic,
          function (e) {
            console.log("删除了对象", e);
          }
        );
      }
      EventBus.$on("updateCartesian", (param) => {
        //根据编辑对象的id找到对应标记列表里的数据项，对应进行编辑。
        this.editRoamingPointByUid(param.graphic.uuid, param.cartesianXYZ);
      });

      let iurl, gl, tposition;
      this.$GLOBAL.markDrawGraphicLayer.clear();
      /* if (this.$GLOBAL.markDrawGraphicLayer2) {
				this.$GLOBAL.markDrawGraphicLayer2.clear();
			} */

      let flyToGraphicLayer;
      //分析一般情况下，最大的id就是最后一项，所以这里直接将最后一项id赋初值，用于实际减少变量置换次数，提高程序运行效率。
      let maxId = data[data.length - 1].id;
      this.maxPointName = data[data.length - 1].pointName;
      this.$refs.customRoamingPoint.initCurrPosition(data[data.length - 1]);

      for (let i = 0; i < data.length; i++) {
        let rPColor = this.$GLOBAL.default_markIconColor;
        iurl = "/img/marker/mark" + rPColor.slice(1) + ".png";
        gl = this.$GLOBAL.markDrawGraphicLayer.addGraphic([
          {
            type: "billboard",
            position: new mars3d.LngLatPoint(data[i].x, data[i].y, data[i].z),
            style: {
              image: iurl,
              label: {
                //不需要文字时，去掉label配置即可
                text: data[i].pointName,
                font_size: 26,
                font_family: "黑体",
                color: rPColor,
                outline: true,
                pixelOffsetY: -66,
                visibleDepth: false,
              },
              visibleDepth: false,
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
              //clampToGround: true, //贴地
            },
          },
        ]);

        //定位到最近一次添加的点位。避免长路线添加点位后每次视角都切回第一个点位。
        if (maxId < data[i].id) {
          maxId = data[i].id;
          flyToGraphicLayer = this.$GLOBAL.markDrawGraphicLayer;
        }

        // if (i === 0) {
        // 	//定位到第一个点位
        // 	this.$GLOBAL.markDrawGraphicLayer.flyTo();
        // }
        data[i].uid = gl[0]._id;
      }
      if (flyToGraphicLayer) {
        flyToGraphicLayer.flyTo();
      }
      this.$GLOBAL.markDrawGraphicLayer.unbindContextMenu(true);
      this.bindLayerContextMenu(this.$GLOBAL.markDrawGraphicLayer);
      return data;
    },
    //根据标记对象uid找到编辑对象的数据
    findRoamingPointByUid(uid) {
      return this.tableData.filter(function (fp) {
        return fp.uid === uid;
      });
    },
    //根据标记对象id弹出编辑对象的弹窗，适用于用户直接在地图上移动标记时触发该标记的编辑弹窗。
    editRoamingPointByUid(uid, newXYZ) {
      let rpdata = this.findRoamingPointByUid(uid);
      //alert(point)
      if (rpdata && rpdata.length > 0) {
        //避免地图上标记点移动位置后，移动前弹出表单里填写的信息被重置，且与地图标识显示不同。
        let nowFormData = this.$refs.customRoamingPoint.form;
        let showData = rpdata[0];
        // console.log(55555555555555555555555);
        // console.log(JSON.parse(JSON.stringify(nowFormData)));
        // console.log(JSON.parse(JSON.stringify(showData)));
        //要考虑到一种情况，就是CustomRoamingPoint弹窗还在时，切换了移动的标记。
        if (nowFormData.id === showData.id) {
          if (nowFormData.pointName) {
            showData.pointName = nowFormData.pointName;
          }
          if (nowFormData.title) {
            showData.title = nowFormData.title;
          }
          if (nowFormData.position) {
            showData.position = nowFormData.position;
          }
          if (nowFormData.sort) {
            showData.sort = nowFormData.sort;
          }
          //showData=nowFormData;
        }
        if (newXYZ) {
          let tempArr = newXYZ.split(",");
          if (tempArr[0] !== "undefined") {
            showData.x = tempArr[0];
          }
          if (tempArr[1] !== "undefined") {
            showData.y = tempArr[1];
          }
          if (tempArr[2] !== "undefined") {
            showData.z = tempArr[2];
          }
          showData.position = newXYZ;
        }
        showData.pathName = showData.bimRoamName;
        showData.pathId = showData.bimRoamId;

        let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(
          showData.uid
        );
        layer.flyTo({
          duration: 2,
        });
        layer.hasEdit = true;
        //alert(showData.position)
        this.$GLOBAL.markDrawGraphicLayerObj = layer;
        this.open_roaming_box = "CustomRoamingPoint";
        this.$refs.customRoamingPoint.initFormData(showData);
        this.$refs.customRoamingPoint.isEdit = true;
        this.$refs.customRoamingPoint.title = "编辑";
      }
      // console.log(8888888888888);
      // console.log(JSON.parse(JSON.stringify(rpdata)));
    },
    bindLayerContextMenu(graphicLayer) {
      let that = this;
      graphicLayer.bindContextMenu([
        {
          text: "删除对象",
          iconCls: "fa fa-trash-o",
          show: (event) => {
            const graphic = event.graphic;
            if (!graphic || graphic.isDestroy) {
              return false;
            } else {
              return true;
            }
          },
          callback: function (e) {
            const graphic = e.graphic;
            if (!graphic) {
              return;
            }
            //调用后端接口移除，不应该在这里移除。
            // console.log(e.graphic)
            // console.log(e.graphic.uuid)
            // console.log(121212121212);
            let tempData = that.findRoamingPointByUid(e.graphic.uuid);
            if (tempData[0] && tempData[0].id) {
              that.deleteRPData(tempData[0].id);
            }
            //findRoamingPointByUid(uid);
            //graphicLayer.removeGraphic(graphic)
          },
        },
      ]);
    },
  },
  watch: {},
  destroyed() {
    // this.$GLOBAL.map.removeThing(this.tilesetPlanClip,true) //移除并销毁
    // this.graphicLayer.destroy() //销毁
    if (this.$GLOBAL.markDrawGraphicLayer) {
      this.$GLOBAL.markDrawGraphicLayer.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer, true);
    }
    if (this.$GLOBAL.markDrawGraphicLayer2) {
      this.$GLOBAL.markDrawGraphicLayer2.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
    }
    this.$GLOBAL.markDrawGraphicLayer = null;
    this.$GLOBAL.markDrawGraphicLayer2 = null;
    this.$GLOBAL.markDrawGraphicLayerObj = null;
    this.open_roaming_box = ""; //关闭关联弹窗。

    if (graphicLayer) {
      graphicLayer.clear();
      this.$GLOBAL.map.removeLayer(graphicLayer, true);
      graphicLayer = null;
    }
    if (graphicLayer2) {
      graphicLayer2.clear();
      this.$GLOBAL.map.removeLayer(graphicLayer2, true);
      graphicLayer2 = null;
    }
    if (roamLine) {
      roamLine.stop();
      roamLine = null;
    }
    EventBus.$off("updateCartesian2");
    EventBus.$off("updateCartesian");

    // 取消临时设置，恢复为不允许进入地下。
    const options = { highDynamicRange: true, cameraController: {} };
    options.cameraController["enableCollisionDetection"] = true;
    //console.log("更新了地图参数", options);
    this.$GLOBAL.map.setSceneOptions(options);
  },
};
//console.log(localStorage.getItem(ColorPicker));
